import baseService from '@common/services/base.service';
import store from '@common/store/store';
const tributarioRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store);

let controller = 'CepExterno';

const apidDef = {
  getByCep({ data, reference, filterCepBySede, filterEnderecoExterior }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCep/${data}`, {
      params: {
        filterCepBySede,
        filterEnderecoExterior,
        reference,
      },
    });
  },
  getByCepInterno({ data }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCepInterno/${data}`);
  },
  getByCaixaPostal({ data }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCaixaPostal/${data}`);
  },

  getByCodigoPostal({ codigoPostal, pais }) {
    return http.get(`${tributarioRoute}/${controller}/GetByCodigoPostal/${codigoPostal}/${pais}`);
  },

  getCepSede() {
    return http.get(`${tributarioRoute}/${controller}/getCepSede`);
  },

  suggestionCidade(busca, parameters) {
    const { cep, uf, exterior } = parameters;
    return http.get(`${tributarioRoute}/${controller}/getbycidadesuggestion`, {
      params: { busca, cep, uf, exterior },
    });
  },

  suggestionPais(busca, parameters) {
    return http.get(`${tributarioRoute}/${controller}/getbypaissuggestion`, {
      params: { busca, ...parameters },
    });
  },

  suggestionTipo(data) {
    return http.get(`${commonRoute}/DadosComuns/getbytiposuggestion/noauth?busca=${data}`);
  },

  suggestionLogradouro(busca, parameters) {
    const { cep, uf, cidade, bairro, exterior } = parameters;
    return http.get(`${tributarioRoute}/${controller}/getbylogradourosuggestion`, {
      params: { busca, cep, uf, cidade, bairro, exterior },
    });
  },

  suggestionBairro(busca, parameters) {
    const { cep, uf, cidade, logradouro, exterior } = parameters;
    return http.get(`${tributarioRoute}/${controller}/getbybairrosuggestion`, {
      params: { busca, cep, cidade, uf, logradouro, exterior },
    });
  },
};

export default apidDef;
